export default "__VITE_PUBLIC_ASSET__fb675237__"